// import { createSlice } from '@reduxjs/toolkit';
// import {
//   createFeaturedDeal,
//   updateFeaturedDeal,
//   getAllFeaturedDeals,
//   toggleFeaturedDealStatus,
//   deleteFeaturedDeal,
//   addProductToDeal,
//   removeProductFromDeal,
//   getDealProducts,
// } from './ThunkAction';
// import { iFeaturedDealState, REDUCER_NAME } from './Types';

// const initialState: iFeaturedDealState = {
//   isLoading: false,
//   dealDetail: null,
//   dealList: [],
//   errorMessage: null,
// };

// export const featuredDealSlice = createSlice({
//   name: REDUCER_NAME,
//   initialState,
//   reducers: {
//     resetFeaturedDealState: () => initialState,
//   },
//   extraReducers: (builder) => {
//     builder
//       // Create Featured Deal
//       .addCase(createFeaturedDeal.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(createFeaturedDeal.fulfilled, (state, action) => {
//         state.isLoading = false;
//         if (action.payload?.data) {
//           state.dealList = [action.payload.data, ...state.dealList];
//         }
//       })
//       .addCase(createFeaturedDeal.rejected, (state, action) => {
//         state.isLoading = false;
//         //@ts-ignore
//         state.errorMessage =
//           //@ts-ignore
//           action.payload?.message || 'Failed to create featured deal';
//       })

//       // Get All Featured Deals
//       .addCase(getAllFeaturedDeals.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(getAllFeaturedDeals.fulfilled, (state, action) => {
//         state.isLoading = false;
//         console.log('Fulfilled payload:', action.payload); // Debug log

//         // Handle different response structures
//         if (action.payload) {
//           if (Array.isArray(action.payload.data)) {
//             // Direct array response
//             //@ts-ignore
//             state.dealList = action.payload.data;
//             //@ts-expect-error
//           } else if (action.payload.data?.responseBody?.data) {
//             // Nested response with responseBody
//             //@ts-ignore
//             state.dealList = action.payload.data.responseBody.data;
//             //@ts-ignore
//           } else if (action.payload.data?.data) {
//             // Nested response with data
//             //@ts-ignore
//             state.dealList = action.payload.data.data;
//           } else {
//             // Empty array if no data
//             state.dealList = [];
//           }
//         } else {
//           state.dealList = [];
//         }
//       })
//       .addCase(getAllFeaturedDeals.rejected, (state, action) => {
//         state.isLoading = false;
//         //@ts-ignore
//         state.errorMessage =
//           //@ts-ignore
//           action.payload?.message || 'Failed to fetch featured deals';
//       })

//       // Update Featured Deal
//       .addCase(updateFeaturedDeal.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(updateFeaturedDeal.fulfilled, (state, action) => {
//         state.isLoading = false;
//         if (action.payload?.data) {
//           state.dealList = state.dealList.map((deal) =>
//             deal.id === action.payload?.data.id ? action.payload.data : deal
//           );
//         }
//       })
//       .addCase(updateFeaturedDeal.rejected, (state, action) => {
//         state.isLoading = false;
//         //@ts-ignore
//         state.errorMessage =
//           //@ts-ignore
//           action.payload?.message || 'Failed to update featured deal';
//       })

//       // Toggle Status
//       .addCase(toggleFeaturedDealStatus.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(toggleFeaturedDealStatus.fulfilled, (state, action) => {
//         state.isLoading = false;
//         if (action.payload?.data) {
//           state.dealList = state.dealList.map((deal) =>
//             deal.id === action.payload?.data.id
//               ? { ...deal, status: action.payload.data.status }
//               : deal
//           );
//         }
//       })
//       .addCase(toggleFeaturedDealStatus.rejected, (state, action) => {
//         state.isLoading = false;
//         //@ts-ignore
//         state.errorMessage =
//           //@ts-ignore
//           action.payload?.message || 'Failed to toggle status';
//       })

//       // Delete Featured Deal
//       .addCase(deleteFeaturedDeal.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(deleteFeaturedDeal.fulfilled, (state, action) => {
//         state.isLoading = false;
//         if (action.payload?.data) {
//           state.dealList = state.dealList.filter(
//             (deal) => deal.id !== action.payload?.data.id
//           );
//         }
//       })
//       .addCase(deleteFeaturedDeal.rejected, (state, action) => {
//         state.isLoading = false;
//         //@ts-ignore
//         state.errorMessage =
//           //@ts-ignore
//           action.payload?.message || 'Failed to delete featured deal';
//       })


//       // Add these to your extraReducers in the slice

// .addCase(addProductToDeal.pending, (state) => {
//   state.isLoading = true;
// })
// .addCase(addProductToDeal.fulfilled, (state, action) => {
//   state.isLoading = false;
//   // Refresh deals to update product count
//   //@ts-ignore
//   dispatch(getAllFeaturedDeals());
// })
// .addCase(addProductToDeal.rejected, (state, action) => {
//   state.isLoading = false;
//   //@ts-ignore
//   state.errorMessage = action.payload?.message || 'Failed to add product';
// })

// .addCase(removeProductFromDeal.pending, (state) => {
//   state.isLoading = true;
// })
// .addCase(removeProductFromDeal.fulfilled, (state, action) => {
//   state.isLoading = false;
//   // Refresh deals to update product count
//   //@ts-ignore
//   dispatch(getAllFeaturedDeals());
// })
// .addCase(removeProductFromDeal.rejected, (state, action) => {
//   state.isLoading = false;
//   //@ts-ignore
//   state.errorMessage = action.payload?.message || 'Failed to remove product';
// })

// .addCase(getDealProducts.pending, (state) => {
//   state.isLoading = true;
// })
// .addCase(getDealProducts.fulfilled, (state, action) => {
//   state.isLoading = false;
//   // You might want to store these in state if needed
// })
// .addCase(getDealProducts.rejected, (state, action) => {
//   state.isLoading = false;
//   //@ts-ignore
//   state.errorMessage = action.payload?.message || 'Failed to get deal products';
// })
//   },
// });

// export const { resetFeaturedDealState } = featuredDealSlice.actions;
// export default featuredDealSlice.reducer;


import { createSlice } from '@reduxjs/toolkit';
import {
  createFeaturedDeal,
  updateFeaturedDeal,
  getAllFeaturedDeals,
  toggleFeaturedDealStatus,
  deleteFeaturedDeal,
  addProductToDeal,
  removeProductFromDeal,
  getDealProducts,
} from './ThunkAction';
import { iFeaturedDealState, REDUCER_NAME } from './Types';

const initialState: iFeaturedDealState = {
  isLoading: false,
  dealDetail: null,
  dealList: [],
  errorMessage: null,
  //@ts-ignore
  dealProducts: [], // Added for storing products in a deal
};

export const featuredDealSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetFeaturedDealState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Create Featured Deal
      .addCase(createFeaturedDeal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createFeaturedDeal.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.data) {
          state.dealList = [action.payload.data, ...state.dealList];
        }
      })
      .addCase(createFeaturedDeal.rejected, (state, action) => {
        state.isLoading = false;
        //@ts-ignore
        state.errorMessage = action.payload?.message || 'Failed to create featured deal';
      })

      // Get All Featured Deals
      .addCase(getAllFeaturedDeals.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllFeaturedDeals.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          if (Array.isArray(action.payload.data)) {
            //@ts-ignore
            state.dealList = action.payload.data;
            //@ts-ignore
          } else if (action.payload.data?.responseBody?.data) {
            //@ts-ignore
            state.dealList = action.payload.data.responseBody.data;
            //@ts-ignore
          } else if (action.payload.data?.data) {
            //@ts-ignore
            state.dealList = action.payload.data.data;
          } else {
            state.dealList = [];
          }
        } else {
          state.dealList = [];
        }
      })
      .addCase(getAllFeaturedDeals.rejected, (state, action) => {
        state.isLoading = false;
        //@ts-ignore
        state.errorMessage = action.payload?.message || 'Failed to fetch featured deals';
      })

      // Update Featured Deal
      .addCase(updateFeaturedDeal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateFeaturedDeal.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.data) {
          state.dealList = state.dealList.map((deal) =>
            deal.id === action.payload?.data.id ? action.payload.data : deal
          );
        }
      })
      .addCase(updateFeaturedDeal.rejected, (state, action) => {
        state.isLoading = false;
        //@ts-ignore
        state.errorMessage = action.payload?.message || 'Failed to update featured deal';
      })

      // Toggle Status
      .addCase(toggleFeaturedDealStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(toggleFeaturedDealStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.data) {
          state.dealList = state.dealList.map((deal) =>
            deal.id === action.payload?.data.id
              ? { ...deal, status: action.payload.data.status }
              : deal
          );
        }
      })
      .addCase(toggleFeaturedDealStatus.rejected, (state, action) => {
        state.isLoading = false;
        //@ts-ignore
        state.errorMessage = action.payload?.message || 'Failed to toggle status';
      })

      // Delete Featured Deal
      .addCase(deleteFeaturedDeal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteFeaturedDeal.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.data) {
          state.dealList = state.dealList.filter(
            (deal) => deal.id !== action.payload?.data.id
          );
        }
      })
      .addCase(deleteFeaturedDeal.rejected, (state, action) => {
        state.isLoading = false;
        //@ts-ignore
        state.errorMessage = action.payload?.message || 'Failed to delete featured deal';
      })

      // Add Product to Deal
      .addCase(addProductToDeal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addProductToDeal.fulfilled, (state) => {
        state.isLoading = false;
        // The actual update will happen when we refresh the deals list
      })
      .addCase(addProductToDeal.rejected, (state, action) => {
        state.isLoading = false;
        //@ts-ignore
        state.errorMessage = action.payload?.message || 'Failed to add product';
      })

      // Remove Product from Deal
      .addCase(removeProductFromDeal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(removeProductFromDeal.fulfilled, (state) => {
        state.isLoading = false;
        // The actual update will happen when we refresh the deals list
      })
      .addCase(removeProductFromDeal.rejected, (state, action) => {
        state.isLoading = false;
        //@ts-ignore
        state.errorMessage = action.payload?.message || 'Failed to remove product';
      })

      // Get Deal Products
      .addCase(getDealProducts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDealProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.data) {
          //@ts-ignore
          state.dealProducts = action.payload.data;
        }
      })
      .addCase(getDealProducts.rejected, (state, action) => {
        state.isLoading = false;
        //@ts-ignore
        state.errorMessage = action.payload?.message || 'Failed to get deal products';
      });
  },
});

export const { resetFeaturedDealState } = featuredDealSlice.actions;
export default featuredDealSlice.reducer;